import { AdminLayout } from '@/components/layouts'
import CommunityForm from './CommunityForm'

interface NewProps {
  specialties: string[]
}

export default function New({ specialties }: NewProps) {
  return (
    <AdminLayout
      title="Nouvelle communauté"
      breadcrumbs={[
        { label: 'Communautés', href: '/admin/communities' },
        { label: 'Nouvelle communauté' }
      ]}
    >
      <div className="max-w-2xl">
        <CommunityForm specialties={specialties} />
      </div>
    </AdminLayout>
  )
}
